





























import Vue, { PropType } from "vue";

/* Interfaces */
import { IGridElement } from "@/interfaces/IGridElement";

export default Vue.extend({
  props: {
    gridElements: {
      type: Array as PropType<IGridElement[]>,
      required: true,
    },
  },
  methods: {
    select(id: number): void {
      this.$emit("selected", id);
    },
  },
});
